/** Display helpers for admin screens (ISS-188). */

export type InviteStatus = 'pending' | 'accepted' | 'expired' | 'revoked';

/** The status staff should see: a pending invite past its expiry is expired, whatever the row says. */
export function effectiveInviteStatus<S extends string>(
  invite: { status: S; expires_at?: string | null },
  now: Date = new Date(),
): S | 'expired' {
  if (invite.status !== 'pending' || !invite.expires_at) return invite.status;
  const expires = new Date(invite.expires_at).getTime();
  return Number.isFinite(expires) && expires < now.getTime() ? 'expired' : invite.status;
}

/** A company's industry as its name ("Film & Television"), not its stored slug ("film"). */
export function industryLabel(
  value: string | null | undefined,
  industries: Array<{ name: string; slug?: string }>,
): string {
  if (!value) return '-';
  const hit = industries.find((i) => i.slug === value || i.name === value);
  return hit?.name ?? value;
}
